import { FC } from 'react';
import DentalIcon from 'assets/images/claims/dental.svg';
import HospitalisationIcon from 'assets/images/claims/hospitalisation.svg';
import MaternityIcon from 'assets/images/claims/maternity.svg';
import OutpatientIcon from 'assets/images/claims/outpatient.svg';
import { ClaimType } from 'all-in-one-shared-api';

export interface ClaimTypeIconProp {
  claimType: ClaimType;
}

enum CLAIM_TYPE {
  OUT_PATIENT = 'OP',
  DENTAL = 'DEN',
  HOSPITALISATION = 'HOSP',
  MATENITY = 'MAT',
}

const ClaimTypeIcon: FC<ClaimTypeIconProp> = ({ claimType }) => {
  const { code, description } = claimType;
  switch (code) {
    case CLAIM_TYPE.DENTAL:
      return <img src={DentalIcon} alt={description} />;
    case CLAIM_TYPE.HOSPITALISATION:
      return <img src={HospitalisationIcon} alt={description} />;
    case CLAIM_TYPE.OUT_PATIENT:
      return <img src={OutpatientIcon} alt={description} />;
    case CLAIM_TYPE.MATENITY:
      return <img src={MaternityIcon} alt={description} />;
    default:
      return null;
  }
};

export default ClaimTypeIcon;
